import * as React from 'react';
import styled from 'styled-components';
import { Checkbox } from '@ixicare/ui';
import { Description, Option, Reveal } from './choiceStyles';

interface Props {
  // Unique on the page. Also ties the description label to the input.
  id: string;
  title: string;
  description?: string;
  checked: boolean;
  // Checked, but not the carer's to change. The reason belongs in `description`.
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
  // Revealed while checked.
  children?: React.ReactNode;
}

// One independently switchable setting, with an explanation and something revealed when it is on.
// Deliberately a single item rather than a list like ChoiceList: two checkboxes share no state -
// each has its own checked, its own handler and its own subtree - so a choices[] array would be
// more code and would hide the asymmetry between them.
const CheckboxChoice: React.FC<Props> = ({ id, title, description, checked, disabled, onCheckedChange, children }) => (
  <CheckboxOption>
    {/* onCheckedChange only: @ixicare/ui's Checkbox spreads the rest of its props after its own
        onChange, so passing onChange as well would replace the handler that fires this one. */}
    <Checkbox id={id} label={title} checked={checked} disabled={disabled} onCheckedChange={onCheckedChange} />
    {description && <Description htmlFor={id}>{description}</Description>}
    {checked && children && <Reveal>{children}</Reveal>}
  </CheckboxOption>
);

// Checkbox.module.css leaves room under a labelled checkbox; the description belongs 2px under the
// title, the same distance the radio rows use.
const CheckboxOption = styled(Option)`
  > div:first-child {
    margin-bottom: 0;
  }
`;

export default CheckboxChoice;
